import { Component, OnInit } from '@angular/core';
import { SalesInvoice } from '../billing/sales-invoice';
import { HttpService } from '../service/http.service';

@Component({
  selector: 'app-sales-invoices',
  templateUrl: './sales-invoices.component.html',
  styleUrls: ['./sales-invoices.component.css']
})
export class SalesInvoicesComponent implements OnInit {

  invoices: SalesInvoice[] = [];

  constructor(
    private httpService: HttpService
  ) { }

  ngOnInit(): void {

    this.httpService.getAllInvoices().subscribe(res => {
      this.invoices = res;
      console.log(res);
    });
  }

}
